// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1_oOf","cls2":"CitationModal-cls2_UUU CitationModal-cls1_oOf"};